// /passkey: offered once right after signing in, to an account with no
// passkey (until this browser says "later"). Settings has the same later.
import { useRouter } from "@tanstack/react-router";
import { m } from "@trameria/cloud-i18n";
import { Button, ErrorLine } from "@trameria/ui-core";
import { HOME } from "../auth/next";
import { dismissPasskeyPrompt } from "../auth/passkey-name";
import { useAddPasskey } from "../queries";
import { SignedOutPage } from "./signed-out-page";

export function PasskeyPage({ next }: { next?: string }) {
  const router = useRouter();
  const add = useAddPasskey();
  const go = () => router.history.push(next ?? HOME);
  return (
    <SignedOutPage title={m.web_passkey_title()}>
      <p className="text-[13px] leading-[1.7] [word-break:auto-phrase]">
        {m.web_passkey_lead()}
      </p>
      <div className="mt-5 flex flex-col gap-2">
        <Button
          variant="primary"
          className="h-10 w-full"
          disabled={add.isPending}
          onClick={() => add.mutate(undefined, { onSuccess: go })}
        >
          {m.web_passkey_register()}
        </Button>
        {add.isError && (
          <ErrorLine>{m.web_passkey_register_failed()}</ErrorLine>
        )}
        <Button
          className="h-10 w-full"
          disabled={add.isPending}
          onClick={() => {
            dismissPasskeyPrompt();
            go();
          }}
        >
          {m.web_passkey_later()}
        </Button>
      </div>
      <p className="mt-3 text-[12px] leading-[1.7] text-muted [word-break:auto-phrase]">
        {m.web_passkey_later_note()}
      </p>
    </SignedOutPage>
  );
}
